var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{key:Date.now(),class:_vm.rootClass},[_c('div',{ref:"canvas",class:`${_vm.rootClass}__canvas`}),_vm._v(" "),_c('div',{ref:"plane",class:`${_vm.rootClass}__plane`},[(_vm.displacementImg)?_c('SmartImage',{attrs:{"settings":_vm.displacementImg},on:{"onLoad":_vm.handleLoad}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }